import { createContext, useContext } from 'react';
import { useReactFlowStore } from 'assets/js/pages/engage/workflows/utils/store';

interface ICanvasNodeContext {
    isSelected: boolean;
    isError: boolean;
    id: string;
}

const CanvasNodeContext = createContext<ICanvasNodeContext>({
    isSelected: false,
    isError: false,
    id: '',
});

const useCurrentNode = () => {
    const { id } = useContext(CanvasNodeContext);
    const { getNode } = useReactFlowStore(({ getNode }) => ({ getNode }));
    return getNode(id);
};

export { useCurrentNode, CanvasNodeContext };
